export var DeceasedNamesHeadingEnum;
(function (DeceasedNamesHeadingEnum) {
    DeceasedNamesHeadingEnum["Name"] = "Name";
    DeceasedNamesHeadingEnum["Surname"] = "surname";
    DeceasedNamesHeadingEnum["StartDate"] = "Name given / changed date";
})(DeceasedNamesHeadingEnum || (DeceasedNamesHeadingEnum = {}));
export const DeceasedNamesHeadingEnumHeadingLookup = new Map([
    [DeceasedNamesHeadingEnum.Name, "name"],
    [DeceasedNamesHeadingEnum.Surname, "surname"],
]);
